import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-tanhao",
  "use": "icon-icon-tanhao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-tanhao\"><path d=\"M510.9 64.7C263.8 64.7 63.4 265 63.4 512.1s200.3 447.5 447.4 447.5 447.4-200.3 447.4-447.5S758 64.7 510.9 64.7z m51.8 732.2H457.2V672.5h105.5v124.4z m1.9-355.1l-25.4 186.6h-58.6l-23.4-186.6v-197h107.4v197z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-tanhao.svg
// module id = np6B
// module chunks = 3